import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NatSpecColor} from '../models/colors.model';

@Injectable()
export class SizesService {
  constructor(private _api: ApiService,
              private _http: HttpClient) {
  }

  public getSizes(): Observable<any> {
    return this._api.get('/productSizes');
  }
  public updateSize(body: NatSpecColor, sizeId: number): Observable<any> {
    return this._api.put('/productSizes/' + sizeId, body);
  }
  public newSize(body: any): Observable<any> {
    return this._api.post('/productSizes', body);
  }

}
